"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferListDesktop = void 0;
var offerListDesktop_1 = require("./offerListDesktop");
Object.defineProperty(exports, "OfferListDesktop", { enumerable: true, get: function () { return __importDefault(offerListDesktop_1).default; } });
